export default __webpack_public_path__ + "static/media/phone.927837fc.svg";